import { FlexBox, SPACING, Typography } from "@joonapp/web-shared"
import { useTranslation } from "react-i18next"

import useAIQuestStore from "./hooks/useAIQuestStore"

const QuestAIError = () => {
  const { error } = useAIQuestStore()
  const { t } = useTranslation()
  if (!error) return null

  return (
    <FlexBox direction="column" gap={SPACING.space4}>
      <Typography variant="aiBody" textAlign="left">
        {t("JOONIPER_ERROR_TITLE")}
      </Typography>
      <Typography variant="aiBody">{t("JOONIPER_ERROR_SUB")}</Typography>
    </FlexBox>
  )
}

export default QuestAIError
